export function examFindings(data) {
  return {
    type: 'EXAM_FINDINGS',
    data
  };
}

export function examSelectedFinding(data) {
  return {
    type: 'EXAM_SELECTED_FINDING',
    data
  };
}

export function examFindingInfo(data) {
  return {
    type: 'EXAM_FINDING_INFO',
    data
  };
}

export function examFindingReset() {
  return {
    type: 'EXAM_FINDING_RESET',
  };
}